module.exports = __webpack_public_path__ + "img/u15190.afb6767d.png";